import { SectionHeading, SectionLabel } from "./Section";

const cards = [
    {
        title: "Scattered data",
        body: "Reports live in Slack, Excel, WhatsApp, dashboards, and inboxes. Nothing agrees. Nothing arrives together.",
        icon: (
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
                <path d="M4 6h6M4 12h10M4 18h7M20 6l-5 5 5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        span: "lg:col-span-2",
    },
    {
        title: "Delayed decisions",
        body: "By the time information reaches the CEO, the moment to act is already gone.",
        icon: (
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
                <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        span: "",
    },
    {
        title: "No real-time money impact",
        body: "Approvals happen blind. Nobody can tell you what the decision does to cash, runway, or profit — before you say yes.",
        icon: (
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
                <path d="M3 12h4l2-6 4 12 2-6h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        span: "lg:col-span-3",
    },
];

export default function Problem() {
    return (
        <section id="problem" data-testid="problem-section" className="relative py-28 sm:py-36">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="reveal max-w-3xl">
                    <SectionLabel num="01">The Problem</SectionLabel>
                    <SectionHeading className="mt-6">
                        CEOs don’t need more dashboards.
                        <br />
                        They need{" "}
                        <span className="italic text-violet-600 font-normal">
                            decisions
                        </span>
                        .
                    </SectionHeading>
                    <p className="mt-6 text-[15px] sm:text-lg text-neutral-600 leading-relaxed max-w-2xl">
                        Founders are trapped between scattered reports, delayed
                        updates, WhatsApp messages, Excel sheets, meetings, and
                        disconnected tools. By the time data reaches the CEO,
                        the decision is already late.
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-5">
                    {cards.map((c, i) => (
                        <div
                            key={c.title}
                            data-testid={`problem-card-${i + 1}`}
                            className={`reveal glass rounded-3xl p-8 sm:p-10 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(139,92,246,0.25)] transition-all duration-500 ${c.span}`}
                            style={{ transitionDelay: `${i * 80}ms` }}
                        >
                            <div className="flex items-center justify-between">
                                <span className="inline-flex items-center justify-center h-10 w-10 rounded-2xl bg-neutral-50 border border-black/5 text-neutral-700">
                                    {c.icon}
                                </span>
                                <span className="font-mono-alt text-[11px] text-neutral-400">
                                    0{i + 1}
                                </span>
                            </div>
                            <div className="mt-8 font-display text-2xl sm:text-3xl font-medium tracking-tight text-black">
                                {c.title}
                            </div>
                            <p className="mt-3 text-[14px] sm:text-[15px] text-neutral-600 leading-relaxed">
                                {c.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
